import { Store, useStore } from '@tanstack/react-store';

type MobileFiltersStore = {
    isMobileFiltersOpen: boolean;
};

const store = new Store<MobileFiltersStore>({
    isMobileFiltersOpen: false,
});

function setIsMobileFiltersOpen(isMobileFiltersOpen: boolean) {
    store.setState((state) => {
        return {
            ...state,
            isMobileFiltersOpen,
        };
    });
}

export function useMobileFilters() {
    const isMobileFiltersOpen = useStore(
        store,
        (state) => state.isMobileFiltersOpen,
    );

    return { isMobileFiltersOpen, setIsMobileFiltersOpen };
}
